// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"qX tu","ribbon":"qY tD","title":"qZ tw","year":"q0 tx","genres":"q1 tC","duration":"q2","buttonWrapper":"q3 ty","button":"q4 tz","price":"q5","upperParts":"q6"};